import * as Yup from 'yup';
//utils
import {emailSchema, phoneSchema} from '@/utils/validation';
//types
import {TableAndTickets, TicketTableAndTicketsPurchaser} from '@/utils/types';
//helpers
import {ADD_TABLE_TICKET_STEP} from './helpers';
//enums
import {PAYMENT_METHOD} from '@/utils/enums';
//constants
import {FIELD, ID, IS_VIP} from '@/utils/constants';

export type TableAndTicketsWithAttending = TableAndTickets & {purchaserIsNotAttending?: boolean};

export type AddTableTicketFormValues = {
	purchaser: Omit<TicketTableAndTicketsPurchaser, typeof IS_VIP | typeof ID>;
	paymentOption: string;
	isPaid?: boolean;
	isCoverFee: boolean;
	setTables: TableAndTicketsWithAttending[];
};

export const initialValues: AddTableTicketFormValues = {
	purchaser: {
		firstName: '',
		lastName: '',
		email: '',
		phoneNumber: '',
		meals: [],
		isUnknown: false,
	},
	paymentOption: PAYMENT_METHOD.CREDIT_CARD,
	isCoverFee: true,
	setTables: [],
};

export const validationSchema = (activeStep: number, isMobile?: boolean) => {
	return Yup.object().shape({
		...(activeStep === ADD_TABLE_TICKET_STEP.TICKET_INFO && {
			setTables: Yup.array().min(1, 'Minimum 1 tickets tier is required'),
		}),

		...(activeStep === ADD_TABLE_TICKET_STEP.ATTENDEES_INFO && {
			purchaser: Yup.object().shape({
				firstName: Yup.string().required('First name is required'),
				lastName: Yup.string().required('Last name is required'),
				email: emailSchema,
				phoneNumber: phoneSchema,
			}),
			setTables: Yup.array().of(
				Yup.object().shape({
					name: Yup.string().required('Table name is required'),
					attendees: Yup.array().of(
						Yup.object().shape({
							[FIELD.firstName]: Yup.string(),
							[FIELD.lastName]: Yup.string(),
							[FIELD.email]: Yup.string().email('Invalid email format'),
							[FIELD.phoneNumber]: Yup.string(),
							[FIELD.meals]: Yup.array().nullable(),
						})
					),
				})
			),
		}),
	});
};
